import { addressStringBase } from '@/services/general/general';
import * as tableConfig from '@/configuration/tableConfig';
import { PARAMETRES_KEYS } from '@/store/modules/parametrage-mutation-type';

export const COLUMNS = [
  {
    field: 'urlLogo',
    label: '',
    searchable: false,
    sortable: false,
    width: '30px'
  },
  {
    field: 'produitFace.codePanneau',
    label: 'ajoutProduitExistant.column.code',
    searchable: true,
    sortable: true,
    'header-class': 'is-size-7 has-text-grid-1 pa-20',
    'cell-class': 'is-size-7 has-text-default px-20',
    width: '150px',
    searchField: 'codePanneau',
    searchType: tableConfig.FILTRE_TYPE_INPUT
  },
  {
    field: 'etatIcone',
    label: '',
    searchable: false,
    sortable: false,
    width: '30px'
  },
  {
    field: 'tiers.nomCommercial',
    label: 'ajoutProduitExistant.column.regie',
    searchable: true,
    sortable: true,
    'header-class': 'is-size-7 has-text-grid-1 pa-20',
    'cell-class': 'is-size-7 has-text-default px-20',
    searchField: 'tiersNomCommercial',
    searchType: tableConfig.FILTRE_TYPE_INPUT
  },
  {
    field: 'produitFace.format',
    label: 'ajoutProduitExistant.column.format',
    searchable: true,
    sortable: true,
    'header-class': 'is-size-7 has-text-grid-1 pa-20',
    'cell-class': 'is-size-7 has-text-default px-20',
    width: '150px',
    searchField: 'format',
    searchType: tableConfig.FILTRE_TYPE_AUTOCOMPLETE_PARAMS,
    target: PARAMETRES_KEYS.materielFormat,
  },
  {
    field: 'produitFace.materielType',
    label: 'ajoutProduitExistant.column.materiel',
    searchable: true,
    sortable: true,
    'header-class': 'is-size-7 has-text-grid-1 pa-20',
    'cell-class': 'is-size-7 has-text-default px-20',
    width: '150px',
    searchField: 'materiel',
    searchType: tableConfig.FILTRE_TYPE_AUTOCOMPLETE_PARAMS,
    target: PARAMETRES_KEYS.materielType,
  },
  {
    field: 'adresse',
    format: (row) => addressStringBase(row.produitFace.adresse),
    label: 'ajoutProduitExistant.column.adresse',
    searchable: true,
    sortable: false,
    'header-class': 'is-size-7 has-text-grid-1 pa-20',
    'cell-class': 'is-size-7 has-text-default px-20',
    searchField: 'adresse',
    searchType: tableConfig.FILTRE_TYPE_INPUT
  },
  {
    field: 'produitFace.adresse.codePostal',
    label: 'ajoutProduitExistant.column.codePostal',
    searchable: true,
    sortable: true,
    'header-class': 'is-size-7 has-text-grid-1 pa-20',
    'cell-class': 'is-size-7 has-text-default px-20',
    width: '150px',
    searchField: 'codePostal',
    searchType: tableConfig.FILTRE_TYPE_INPUT
  },
  {
    field: 'produitFace.adresse.ville',
    label: 'ajoutProduitExistant.column.ville',
    searchable: true,
    sortable: true,
    'header-class': 'is-size-7 has-text-grid-1 pa-20',
    'cell-class': 'is-size-7 has-text-default px-20',
    width: '150px',
    searchField: 'ville',
    searchType: tableConfig.FILTRE_TYPE_INPUT
  },
];
